<script lang="ts">
	// shadcn-svelte Tabs on the genuine bits-ui Tabs primitive, RESTYLED to the
	// price-check tokens: underline tabs — a muted trigger that turns brand-colored
	// with a brand underline when active. NO arbitrary `[..]` values.
	import { Tabs as TabsPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		value = $bindable(),
		class: className,
		...restProps
	}: TabsPrimitive.RootProps = $props();
</script>

<TabsPrimitive.Root
	bind:value={value as never}
	bind:ref
	data-slot="tabs"
	class={cn("flex flex-col gap-5", className)}
	{...restProps}
/>
